import { Card, CardContent, Tooltip, useMediaQuery, useTheme } from "@mui/material"
import components from "../../theme/components";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { VideoModal } from "../shared/videoModal";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import welcomeThumb1 from "../../assets/images/welcome-video-play.jpg";
import welcomeThumb2 from "../../assets/images/welcome-video.jpg";

export const DisplayAdvertisement: React.FC = () => {
    const { videos } = useSelector((state: RootState) => state.user);
    const [videoActive, setVideoActive] = useState<boolean>(false);
        const theme = useTheme();
        const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    return (
        <Card sx={components.advertisementCard} style={{marginTop: isMobile ? 0 : 15, marginBottom: isMobile ? 15 : 0}}>
            <VideoModal 
                isOpen={videoActive} 
                onClose={() => setVideoActive(false)} 
                videoList={[
                    videos.welcome.video
                ]}
                thumbnailList={[
                    videos.welcome.thumb2 ?? welcomeThumb2
                ]}
                subtitle={videos.welcome.subtitle}
                name={"Welcome"}
                playedFrom={"Dashboard"}
                assessmentName={"Welcome Video"}
            />
            <Link to="" onClick={() => setVideoActive(true)}>
                {/* <Tooltip title={"Click here to play the walkthrough video"}> */}
                    <CardContent sx={{p: 0, '&:last-child': { pb: 0 }, zIndex: 1, ":hover .thumb": {opacity: 0.5}, ":hover .label": {opacity: 1}}}>
                        <img
                            onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.src = welcomeThumb1;
                            }}
                            className="thumb"
                            src={
                                videos.welcome.thumb1
                            }
                            style={{ width: "100%", marginBottom: -5, zIndex: 0 }}
                        />
                    </CardContent>
                {/* </Tooltip> */}
            </Link>
        </Card>
    )
}